import React from 'react';
import { TrackingScript } from './index';

/**
 * Add tracking script.
 */
// export const onClientEntry = ( _, plugin ) => {
//
//   if( ! plugin || ! plugin.devmode ) {
//     return;
//   }
//
//   return(
//     <TrackingScript accoundId={ plugin.accountId } />
//   );
//
// }

/**
 * Watch all form submissions.
 */
// export const wrapRootElement = ( { element }, plugin ) => {
//
//   if( typeof vgo !== 'function' ) {
//     return element;
//   }
//
//   document.addEventListener( 'submit', e => {
//
//     let email = null;
//     let hasError = false;
//
//     for( let el of e.target.elements ) {
//
//       if( el.closest( '.has-error' ) ) {
//         hasError = true;
//       }
//       else if( el.name.toLowerCase() === 'email' || el.id && el.id.toLowerCase() === 'email' ) {
//         email = el.value;
//       }
//     }
//
//     console.log( email );
//
//     if( hasError ) {
//       return;
//     }
//
//
//
//   } );
//
//   return element;
//
// }


/**
 * Send pageview when route changes.
 *
 * Much of this is borrowed from https://github.com/gatsbyjs/gatsby/tree/master/packages/gatsby-plugin-google-analytics
 */
export const onRouteUpdate = ( { location }, plugin ) => {

  if( ! plugin.devmode && process.env.NODE_ENV !== 'production' || ! window.vgo ) {
    return;
  }

  // Minimum delay for reactHelmet's requestAnimationFrame
  const delay = Math.max( 32, plugin.pageSendDelay || 0 );

  setTimeout( sendPageView, delay );

}

/**
 * Send page view.
 */
function sendPageView() {

  window.vgo( 'update' );
  window.vgo( 'process' );

}